var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "v-application v-application--is-ltr",
        "max-width": "580px",
        fullscreen: !_vm.$vuetify.breakpoint.mdAndUp,
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v("Termine Absage?"),
          ]),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-textarea", {
                attrs: {
                  label: "Kommentar für die Absage",
                  outlined: "",
                  dense: "",
                  rows: "3",
                  "auto-grow": "",
                },
                model: {
                  value: _vm.rejectionComment,
                  callback: function ($$v) {
                    _vm.rejectionComment = $$v
                  },
                  expression: "rejectionComment",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "justify-end" },
            [
              _c(
                "v-btn",
                {
                  attrs: { outlined: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      _vm.isOpen = false
                    },
                  },
                },
                [_vm._v("Abbrechen")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "confirm-delete-btn",
                  attrs: { depressed: "", color: "error" },
                  on: { click: _vm.confirmRejection },
                },
                [_vm._v("Absage")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }